exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.question_drag_icon[data-v-1b5ea9f1]:hover {\n  cursor: grab;\n}\n", ""]);

// exports
